/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Settings_About_SourcesInputs */

const en_ui_settings_about_sources = /** @type {(inputs: Ui_Settings_About_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scientific Sources`)
};

const de_ui_settings_about_sources = /** @type {(inputs: Ui_Settings_About_SourcesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wissenschaftliche Quellen`)
};

/**
* | output |
* | --- |
* | "Scientific Sources" |
*
* @param {Ui_Settings_About_SourcesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_settings_about_sources = /** @type {((inputs?: Ui_Settings_About_SourcesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Settings_About_SourcesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_settings_about_sources(inputs)
	return de_ui_settings_about_sources(inputs)
});